export const CURRENCIES_FILED = {
  USD: { symbol: "$", prefix: true, postfix: false },
  EUR: { symbol: "€", prefix: true, postfix: false },
  GBP: { symbol: "£", prefix: true, postfix: false },
  INR: { symbol: "₹", prefix: true, postfix: false },
  JPY: { symbol: "¥", prefix: true, postfix: false },
  CNY: { symbol: "¥", prefix: true, postfix: false },
  AUD: { symbol: "A$", prefix: true, postfix: false },
  CAD: { symbol: "C$", prefix: true, postfix: false },
  CHF: { symbol: "CHF", prefix: true, postfix: false },
  SEK: { symbol: "kr", prefix: true, postfix: false },
  NZD: { symbol: "NZ$", prefix: true, postfix: false },
  SGD: { symbol: "S$", prefix: true, postfix: false },
  ZAR: { symbol: "R", prefix: true, postfix: false },
  BRL: { symbol: "R$", prefix: true, postfix: false },
  RUB: { symbol: "₽", prefix: true, postfix: false },
  KRW: { symbol: "₩", prefix: true, postfix: false },
  MXN: { symbol: "$", prefix: true, postfix: false },
  TRY: { symbol: "₺", prefix: true, postfix: false },
  AED: { symbol: "د.إ", prefix: true, postfix: false },
  SAR: { symbol: "﷼", prefix: true, postfix: false },
  THB: { symbol: "฿", prefix: true, postfix: false },
  IDR: { symbol: "Rp", prefix: true, postfix: false },
  MYR: { symbol: "RM", prefix: true, postfix: false },
  PHP: { symbol: "₱", prefix: true, postfix: false },
  PLN: { symbol: "zł", prefix: false, postfix: true },
  NOK: { symbol: "kr", prefix: false, postfix: true },
  DKK: { symbol: "kr", prefix: false, postfix: true },
  CZK: { symbol: "Kč", prefix: false, postfix: true },
  HUF: { symbol: "Ft", prefix: false, postfix: true },
  ILS: { symbol: "₪", prefix: true, postfix: false },
};
